import glam from 'glamorous';
import React from 'react';
import { ColumnsUtils, createPureComponent } from 'module/Common';
import { ContentSingleImage } from 'module/Model/Content';
import { MzImageDisplay, Sizes } from 'module/View/Common';
import { SizeForRatio } from 'module/Model/Size';

type ImgWrapperProps = {
  left: number;
  width: number;
};

export const ImgWrapper = glam.div<ImgWrapperProps>(props => ({
  overflow: 'hidden',
  marginLeft: props.left,
  width: props.width,
  pointerEvents: 'all',
}));

type Props = {
  item: ContentSingleImage;
  itemIndex: number;
  cols: ColumnsUtils.ColumnsResult;
  isCover: boolean;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

export const SingleImage = createPureComponent<Props>(
  'SingleImage',
  ({ item, itemIndex, cols, isCover, waitForImage, imageReady }) => {
    const fullWidth = !isCover && ContentSingleImage.isFullWidth(item);
    const noUpscale = !isCover && ContentSingleImage.isNoUpscale(item);
    const width = fullWidth ? cols.size(cols.nbOfColumns) : cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
    const sourceImg = ContentSingleImage.getSource(item);
    const widthUpscale = noUpscale && sourceImg.width < width ? sourceImg.width : width;
    const imgId = sourceImg.id.toString();

    return (
      <ImgWrapper width={widthUpscale} left={cols.position(0)}>
        <MzImageDisplay
          annim={true}
          zoomable={true}
          image={sourceImg}
          size={SizeForRatio.create(widthUpscale, 'auto')}
          onLoad={() => imageReady(imgId)}
          onMount={() => waitForImage(imgId)}
        />
      </ImgWrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/SingleImage.tsx